module.exports = __webpack_public_path__ + "img/app-store-logo-en.a8307960.png";